
import Vue from 'vue'
import wx from 'weixin-js-sdk'
import api from '@/api/groupApi'
import storage from '@/assets/js/storage'

export default async function wxShare(shareObj) {
    let wxconfig = null,
        url = location.href,
        isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        ua = navigator.userAgent.toLowerCase(),
        LowerVersion = false;

    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        var v_weixin = ua.split('micromessenger')[1]
        v_weixin = v_weixin.substring(1,6)
        v_weixin = v_weixin.split(' ')[0]
        if(v_weixin.split('.').length == 2){
            v_weixin = v_weixin + '.0'
        }
        if(v_weixin < '6.6.0'){
            LowerVersion = true
        }
    }
    api.wxShare({
      access_token: localStorage.getItem('token'),
      url: url
    }).then(data=>{
        wxconfig = data;
        // 微信配置功能
        wx.config({
            debug: false,
            appId: wxconfig.appId,
            timestamp: parseInt(wxconfig.timestamp),
            nonceStr: wxconfig.nonceStr,
            signature: wxconfig.signature,
            jsApiList: [
                "onMenuShareTimeline",
                "onMenuShareAppMessage",
                "updateAppMessageShareData",
                "updateTimelineShareData",
            ]
        })
        wx.ready(function () {
            if(!isiOS){
                if(wx.updateAppMessageShareData){
                  wx.updateAppMessageShareData({
                    title: shareObj.title || '', // 分享标题
                    desc: shareObj.desc || '', // 分享描述
                    link: shareObj.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: shareObj.imgUrl || '', // 分享图标
                  }, function(res) {
                    //这里是回调函数
                  });
                }else{
                  wx.onMenuShareTimeline({
                    title: shareObj.title || '', // 分享标题
                    desc: shareObj.desc || '', // 分享描述
                    link: shareObj.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: shareObj.imgUrl || '', // 分享图标
                  });
                }

                if(wx.updateTimelineShareData){
                  wx.updateTimelineShareData({
                    title: shareObj.title || '', // 分享标题
                    link: shareObj.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: shareObj.imgUrl || '', // 分享图标
                  });
                }else {
                  wx.onMenuShareAppMessage({
                    title: shareObj.title || '', // 分享标题
                    link: shareObj.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: shareObj.imgUrl || '', // 分享图标
                  });
                }
            } else {

              if(wx.updateAppMessageShareData){
                wx.updateAppMessageShareData({
                  title: shareObj.title || '', // 分享标题
                  desc: shareObj.desc || '', // 分享描述
                  link: shareObj.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: shareObj.imgUrl || '', // 分享图标
                }, function(res) {
                  //这里是回调函数
                });
              }else{
                wx.onMenuShareTimeline({
                  title: shareObj.title || '', // 分享标题
                  desc: shareObj.desc || '', // 分享描述
                  link: shareObj.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: shareObj.imgUrl || '', // 分享图标
                });
              }

              if(wx.updateTimelineShareData){
                wx.updateTimelineShareData({
                  title: shareObj.title || '', // 分享标题
                  link: shareObj.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: shareObj.imgUrl || '', // 分享图标
                });
              }else {
                wx.onMenuShareAppMessage({
                  title: shareObj.title || '', // 分享标题
                  link: shareObj.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: shareObj.imgUrl || '', // 分享图标
                });
              }

              LowerVersion && wx.onMenuShareTimeline({
                title: shareObj.title || '', // 分享标题
                desc: shareObj.desc || '', // 分享描述
                link: shareObj.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareObj.imgUrl || '', // 分享图标
              });

              LowerVersion && wx.onMenuShareAppMessage({
                title: shareObj.title || '', // 分享标题
                link: shareObj.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareObj.imgUrl || '', // 分享图标
              });


            }
        })      
    })
}

Vue.prototype.$wxShare = wxShare
